import PropTypes from "prop-types";
import React, { Component } from "react";
import MuiCheckbox from "material-ui/Checkbox";
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import theme from "styles/theme";

class Toggle extends Component {
    static contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };

    static propTypes = {
        style: PropTypes.object,
    };

    render() {
        const { ...other } = this.props;
        return <MuiCheckbox {...other} />;
    }
}

export default Toggle;

export const DefaultCheckbox = withStyles({
    root: {
        color: theme.palette.grey,
        padding: 0,
        "&$checked": {
            color: theme.palette.primary1Color,
        },
        "&:hover": {
            backgroundColor: "transparent",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "24px",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);
